import { fragment } from 'ember-data-model-fragments/attributes';
import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';

// Model for squareup.inventory.v3.VendorItemVariation proto.
export default EmberDataBaseFragment.extend({
  itemVariation: fragment('squareup/inventory/v3/catalog-object-item-variation'),
  itemVariationVendorInfoToken: attr('string'),
  itemVariationVendorInfoVersion: attr('number'),
  vendorToken: attr('string'),
  vendorCode: attr('string'),
  unitCost: attr('money-proto'),
  ordinal: attr('number')
}).reopenClass({
  _modelNameForMigration: 'squareup/inventory/v3/vendor-item-variation'
});